<template>
  <div>
    <v-row>
      <v-col cols="3">
        <v-skeleton-loader
          class="ma-auto"
          :loading="process.run"
          transition="scale-transition"
          :tile="false"
          type="card">
          <v-card flat color="transparent" class="border-radius">
            <v-img 
              contain
              width="100%"
              height="auto"
              min-height="270"
              alt="property"
              style="border-radius: 20px;"
              gradient="to top right, rgba(0,0,0,.3), rgba(0,0,0,.3)"
              :src="form.user_image_url">
              <image-input v-model="images">
                <div slot="activator">
                  <v-btn
                    v-if="edit.general"
                    rounded
                    block
                    color="#000"
                    class="text-capitalize white--text"
                    elevation="0"
                    style="position: absolute; bottom: 0px; width: 100%; opacity: 50%;">
                    <v-icon color="white" class="cursor-pointer mr-2">mdi-camera-outline</v-icon> Ubah Gambar
                  </v-btn>
                </div>
              </image-input>
            </v-img>
          </v-card>
        </v-skeleton-loader>
      </v-col>

      <v-col cols="9">
        <!-- GENERAL -->
        <v-skeleton-loader
          class="ma-auto"
          :loading="process.run"
          transition="scale-transition"
          :tile="false"
          type="list-item-three-line">
          <v-card flat class="pa-3" style="background: rgb(255, 255, 255, 0.1);" v-if="!edit.general">
            <v-card-title class="body-2 font-weight-bold d-flex align-center py-0">
              <div>
                Profil General
              </div>
              <v-spacer/>
              <div class="body-2 color-default cursor-pointer" @click="edit.general = true; edit.password = false; reset();">
                <v-icon small :color="style.primary" class="mr-1">mdi-account-edit-outline</v-icon>
                Ubah Profil
              </div>
            </v-card-title>
            <v-divider class="my-2 mx-4"/>
            <v-card-text>
              <p class="body-2 mb-2">
                <v-icon small class="mr-1">mdi-account-circle-outline</v-icon>
                {{ form.user_name }}
              </p>
              <p class="body-2 mb-2">
                <v-icon small class="mr-1">mdi-email-outline</v-icon>
                {{ form.user_email }}
              </p>
              <p class="body-2 mb-2">
                <v-icon small class="mr-1">mdi-cellphone-iphone</v-icon>
                {{ form.user_mobilephone }}
              </p>
            </v-card-text>
            <v-card-text class="py-0">
              <p class="body-2 font-weight-bold mb-2">
                Alamat :
              </p>
              <p class="body-2 mb-2" v-if="Object.keys(form).length > 0">
                <span>
                  {{ Object.keys(form.user_address).length > 0 ? form.user_address : '-' }}
                </span>
              </p>
              <p class="body-2 mb-2">
                {{ form.user_province_name === '' || form.user_province_name === '-' ? '' : `${form.user_province_name},` }}
                {{ form.user_city_name === '' || form.user_city_name === '-' ? '' : `${form.user_city_name}` }}
              </p>
            </v-card-text>
          </v-card>

          <!-- UBAH GENERAL -->
          <v-card flat class="pa-3" style="background: rgb(255, 255, 255, 0.1);" v-if="edit.general">
            <v-card-title class="body-2 font-weight-bold d-flex align-center py-0">
              <div>
                Profil General
              </div>
              <v-spacer/>
              <div class="body-2 red--text cursor-pointer" @click="edit.general = false">
                <v-icon small color="red" class="mr-1">mdi-close</v-icon>
                Batal
              </div>
            </v-card-title>
            <v-divider color="white" class="my-2 mx-4"/>
            <v-card-text class="pb-0">
              <p class="body-2">
                Silahkan masukkan informasi data diri anda, kemudian tekan tombol <b>Update General</b>.
              </p>
              <ValidationObserver ref="observer">
                <v-form class="mb-3">
                  <p class="caption mb-2">
                    <span class="red--text">*</span>
                    <b>Nama Lengkap</b>
                  </p>
                  <ValidationProvider name="Nama Lengkap" rules="required" v-slot="{ errors }">
                    <v-text-field
                      style="width: 50%;"
                      dense
                      outlined
                      single-line
                      :color="style.primary"
                      placeholder="Nama Lengkap"
                      prepend-inner-icon="mdi-account-circle-outline"
                      v-model="form.user_name"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                  
                  <p class="caption mb-2">
                    <span class="red--text">*</span>
                    <b>Alamat Email</b>
                  </p>
                  <ValidationProvider name="Alamat Email" rules="required|email" v-slot="{ errors }">
                    <v-text-field
                      style="width: 40%;"
                      dense
                      outlined
                      single-line
                      :color="style.primary"
                      placeholder="Alamat Email"
                      prepend-inner-icon="mdi-email-outline"
                      v-model="form.user_email"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                  
                  <p class="caption mb-2">
                    <span class="red--text">*</span>
                    <b>Nomor Handphone</b>
                  </p>
                  <ValidationProvider name="Nomor Handphone" rules="required|min:10|max:13" v-slot="{ errors }">
                    <v-text-field
                      style="width: 40%;"
                      dense
                      outlined
                      single-line
                      :color="style.primary"
                      placeholder="Nomor Handphone"
                      prepend-inner-icon="mdi-cellphone-iphone"
                      type="number"
                      :counter="13"
                      v-model="form.user_mobilephone"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>

                  <p class="caption cursor-pointer d-flex align-center" @click="edit.address = !edit.address ? true : false">
                    <v-icon>{{ !edit.address ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                    <span v-if="!edit.address">
                      Anda bisa menambahkan <b>alamat</b> disini
                    </span>
                    <span v-else>
                      <b>Alamat</b> (bisa dikosongi)
                    </span>
                  </p>
                  
                  <div v-if="edit.address">
                    <p class="caption mb-2">
                      <b>Detail Alamat</b>
                    </p>
                    <div style="width: 60%;"
                      class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                      <div class="v-input__control">
                        <div class="v-input__slot">
                          <div class="v-input__prepend-inner">
                            <div class="v-input__icon v-input__icon--prepend-inner">
                              <i aria-hidden="true" class="v-icon notranslate mdi mdi-home-map-marker theme--light"></i>
                            </div>
                          </div>
                          <fieldset aria-hidden="true">
                            <legend style="width: 0px;">
                              <span>​</span>
                            </legend>
                          </fieldset>
                          <div class="v-text-field__slot">
                            <label for="input-147" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">
                              <!-- Alamat / Lokasi -->
                            </label>
                            <gmap-autocomplete placeholder="Alamat" 
                              :value="form.user_address" 
                              :select-first-on-enter="true" 
                              @place_changed="setPlace">
                            </gmap-autocomplete>
                          </div>
                        </div>
                        <div class="v-text-field__details">
                          <div class="v-messages theme--light">
                            <div class="v-messages__wrapper">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <v-row>
                      <v-col cols="12" md="5">
                        <p class="caption mb-2">
                          <b>Provinsi</b>
                        </p>
                        <v-select
                          dense
                          outlined
                          single-line
                          :color="style.primary"
                          placeholder="ex: DI Yogyakarta"
                          :items="config.province"
                          item-value="province_id"
                          item-text="province_name"
                          item-color="color-first"
                          v-model="form.user_province_id"
                          v-on:change="form.user_city_id = ''; form.user_city_name = '';">
                          <template v-slot:append>
                            <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="5">
                        <p class="caption mb-2">
                          <b>Kabupaten</b>
                        </p>
                        <v-select
                          dense
                          outlined
                          single-line
                          :color="style.primary"
                          placeholder="ex: Kab. Sleman"
                          :items="config.city"
                          item-value="city_id"
                          item-text="city_name"
                          item-color="color-first"
                          :disabled="form.user_province_id === ''"
                          v-model="form.user_city_id">
                          <template v-slot:append>
                            <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </div>
                  
                  <v-alert 
                    style="width: 80%;"
                    type="error" 
                    text
                    prominent
                    v-show="error.message.length > 0"
                    v-html="error.message">
                  </v-alert>
                  
                  <v-btn
                    style="width: 40%;"
                    rounded
                    color="#333333"
                    class="white--text text-capitalize"
                    :loading="process.general"
                    :disabled="process.general"
                    @click="updateGeneral">
                    Update General
                  </v-btn>
                </v-form>
              </ValidationObserver>
            </v-card-text>
          </v-card>
        </v-skeleton-loader>

        <!-- PASSWORD -->
        <v-skeleton-loader
          class="ma-auto my-3"
          :loading="process.run"
          transition="scale-transition"
          :tile="false"
          type="list-item-three-line">
          <v-card flat class="pa-3" style="background: rgb(255, 255, 255, 0.1);" v-if="!edit.password">
            <v-card-title class="body-2 font-weight-bold d-flex align-center py-0">
              <div>
                Password
              </div>
              <v-spacer/>
              <div class="body-2 color-default cursor-pointer" @click="edit.password = true; edit.general = false;">
                <v-icon small :color="style.primary" class="mr-1">mdi-shield-key-outline</v-icon>
                Ubah Password
              </div>
            </v-card-title>
            <v-divider class="my-2 mx-4"/>
            <v-card-text class="pb-0">
              <p class="body-2">
                <v-icon small class="mr-1">mdi-account-key-outline</v-icon>
                <v-icon small v-for="i in 6" :key="i">mdi-circle-medium</v-icon>
              </p>
            </v-card-text>
          </v-card>

          <!-- UBAH PASSWORD -->
          <v-card flat class="pa-3" style="background: rgb(255, 255, 255, 0.1);" v-if="edit.password">
            <v-card-title class="body-2 font-weight-bold d-flex align-center py-0">
              <div>
                Password
              </div>
              <v-spacer/>
              <div class="body-2 red--text cursor-pointer" @click="edit.password = false">
                <v-icon small color="red" class="mr-1">mdi-close</v-icon>
                Batal
              </div>
            </v-card-title>
            <v-divider class="my-2 mx-4"/>
            <v-card-text class="pb-0">
              <p class="body-2">
                Silahkan masukkan password lama anda serta password baru yang anda inginkan, kemudian tekan tombol <b>Update Password</b>.
              </p>
              <ValidationObserver ref="observer">
                <v-form style="width: 40%;" class="mb-3">
                  <p class="caption mb-2">
                    <span class="red--text">*</span>
                    <b>Password Lama</b>
                  </p>
                  <ValidationProvider name="Password Lama" rules="required|min:6|max:20" v-slot="{ errors }">
                    <v-text-field
                      dense
                      outlined
                      single-line
                      :color="style.primary"
                      placeholder="Password Lama"
                      prepend-inner-icon="mdi-form-textbox-password"
                      v-model="password.old_password"
                      :type="show.old ? 'text' : 'password'"
                      :append-icon="show.old ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show.old = !show.old"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>

                  <p class="caption mb-2">
                    <span class="red--text">*</span>
                    <b>Password Baru</b>
                  </p>
                  <ValidationProvider name="Password Baru" rules="required|min:6|max:20" v-slot="{ errors }">
                    <v-text-field
                      dense
                      outlined
                      single-line
                      :color="style.primary"
                      placeholder="Password Baru"
                      prepend-inner-icon="mdi-form-textbox-password"
                      v-model="password.new_password"
                      :type="show.new ? 'text' : 'password'"
                      :append-icon="show.new ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show.new = !show.new"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>

                  <v-alert 
                    type="error" 
                    text
                    prominent
                    v-show="error.message.length > 0"
                    v-html="error.message">
                  </v-alert>
                  
                  <v-btn
                    rounded
                    block
                    color="#333333"
                    class="white--text text-capitalize"
                    :loading="process.password"
                    :disabled="process.password"
                    @click="updatePassword">
                    Update Password
                  </v-btn>
                </v-form>
              </ValidationObserver>
            </v-card-text>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { TokenService } from "../../service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  import ImageInput from "@/components/ImageInput.vue";
  export default {
    data () {
      return {
        edit: {
          general: false,
          address: true,
          password: false
        },
        show: {
          old: false,
          new: false
        },
        images: {
          url: ''
        },
        config: {
          province: [],
          city: []
        },
        center: {
          lat: 0,
          lng: 0
        },
        form: {},
        password: {
          old_password: '',
          new_password: ''
        },
        process: {
          run: false,
          general: false,
          password: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      }
    },
    watch: {
      images: {
        handler: function () {
          if (this.images) {
            this.form.user_image_url = this.images.url
          }
        },
        deep: true
      },
      'form.user_province_id': function() {
        let t = this
        let p = this.config.province.filter(function(v) {
          return t.form.user_province_id == v.province_id
        })

        if (p.length > 0) {
          this.form.user_province_name = p[0].province_name
        }

        this.setting().city()
      },
      'form.user_city_id': function() {
        let t = this
        let c = this.config.city.filter(function(v) {
          return t.form.user_city_id == v.city_id
        })

        if (c.length > 0) {
          this.form.user_city_name = c[0].city_name
        }
      }
    },
    components: {
      ImageInput
    },
    mounted () {
      this.fetch()
      this.setting().province()
      this.getGeoLocation()
    },
    methods: {
      fetch() {
        this.process.run = true
        get(`auth/company/user/profile`)
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.run = false
            this.form = res.data
          }
        })
      },
      setting() {
        let t = this
        return {
          async province() {
            get(`location/get-province`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.province = res.data.province
              }
            })
          },
          async city() {
            get(`location/get-city`, {
              params: { province_id: t.form.user_province_id }
            })
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.city = res.data.city
              }
            })
          }
        }
      },
      getGeoLocation() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        })
      },
      setPlace(place) {
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }

        this.form.user_address = place.formatted_address
      },
      reset() {
        this.images = {
          url: this.form.user_image_url
        }

        this.password = {
          old_password: '',
          new_password: ''
        }

        this.process = {
          run: false,
          general: false,
          password: false
        }

        this.error.message = ''
      },
      async updateGeneral() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.general = true
          await post(`auth/company/user/profile-update`, {
            data: {
              name: this.form.user_name,
              email: this.form.user_email,
              mobilephone: this.form.user_mobilephone,
              image_filename:'image.jpg',
              image_url: this.form.user_image_url,
              address: this.form.user_address,
              province_id: this.form.user_province_id,
              province_name: this.form.user_province_name,
              city_id: this.form.user_city_id,
              city_name: this.form.user_city_name
            }
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              let data = {
                company_id: this.form.company.company_id,
                company_roles_id: this.form.user_company_roles_id,
                company_type: this.form.company.company_type,
                company_name: this.form.company.company_name,
                email: this.form.user_email,
                id: this.form.user_id,
                image_url: this.form.user_image_url,
                is_verified: this.form.user_is_verified,
                mobilephone: this.form.user_mobilephone,
                name: this.form.user_name,
                role: this.form.user_company_roles_name,
                type: this.form.company.company_id === '0' ? 'customer' : 'company'
              }

              TokenService.saveToken(
                this.token,
                JSON.stringify(data)
              )

              this.$store.state.user = data

              this.edit.general = false

              this.reset()
              this.fetch()
            } else {
              this.process.general = false
              this.error.message = res.msg
            }
          })
        }
      },
      async updatePassword() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.password = true
          await post(`auth/company/user/profile-update-password`, {
            data: {
              password_old: this.password.old_password,
              password: this.password.new_password
            }
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.edit.password = false

              this.reset()
            } else {
              this.process.password = false
              this.error.message = res.msg
            }
          })
        }
      }
    }
  }
</script>